import { GreyListWrapper, PaddedContainer } from "../styles/styles";
import { Text } from "./Text";

interface GreyStripProps {
  text: string;
  bold?: boolean;
}

export function GreyStrip({ text, bold = true }: GreyStripProps) {
  return (
    <GreyListWrapper>
      <PaddedContainer $py={"8px"} $px={"24px"}>
        <Text text={text} bold={bold} />
      </PaddedContainer>
    </GreyListWrapper>
  );
}
